import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/media";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const timer = useRef<number | null>(null);

  const start = () => {
    if (timer.current) window.clearInterval(timer.current);
    timer.current = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
  };

  useEffect(() => {
    start();
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, []);

  const go = (next: number) => {
    setIndex((next + heroSlides.length) % heroSlides.length);
    start();
  };

  const slide = heroSlides[index];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[420px] w-full md:h-[560px]">
        {heroSlides.map((item, i) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={item.image}
              alt={`${item.title} 焦点海报`}
              title={`${item.title} - 亚洲一区二区在线`}
              className="h-full w-full object-top"
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full w-full flex-col justify-center px-4 md:px-6">
            <div className="max-w-xl" key={slide.id}>
              <span className="inline-flex animate-fade-up items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill"></i>
                {slide.badge}
              </span>
              <h2 className="mt-4 animate-fade-up font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
                {slide.title}
              </h2>
              <p className="mt-4 max-w-md animate-fade-up text-sm leading-relaxed text-background-300 md:text-base">
                {slide.tagline}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${slide.mediaId}`}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-play-fill text-lg"></i>
                  查看详情
                </Link>
                <Link
                  to="/category/movie"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-400/60 bg-background-50/10 px-5 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-compass-3-line text-lg"></i>
                  浏览全部
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-5 right-4 flex items-center gap-2 md:right-6">
          <button
            type="button"
            aria-label="上一张"
            onClick={() => go(index - 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/20"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={() => go(index + 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/20"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        <div className="absolute bottom-6 left-4 flex items-center gap-2 md:left-6">
          {heroSlides.map((item, i) => (
            <button
              key={item.id}
              type="button"
              aria-label={`切换到第${i + 1}张`}
              onClick={() => go(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-8 bg-accent-500" : "w-3 bg-background-50/50"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}